// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__16vTl","rootSmall":"AddTileButton_rootSmall__3oFWI"};